import { useEffect, useState } from 'react';
import { AutofillObserver } from '../helpers/autofill';

/**
 * @param {import('react').RefObject<HTMLInputElement>} inputRef
 * @returns {boolean}
 */
export function useIsAutofilled(inputRef) {
  const [isAutofilled, setIsAutofilled] = useState(false);
  useEffect(() => {
    const input = inputRef.current;
    if (!input) {
      return;
    }
    const observer = new AutofillObserver(entries => {
      for (const entry of entries) {
        if (entry.target === input) {
          setIsAutofilled(entry.isAutofilled);
        }
      }
    });
    observer.observe(input);

    // eslint-disable-next-line consistent-return
    return () => observer.unobserve(input);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return isAutofilled;
}